import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { fetchBranchDetail } from "../../store/slices/branchesSlice";
import EmployeeTab from "./tabs/EmployeeTab";

const BranchEmployeesPage = () => {
  const { branchId } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { detail, loadingDetail, detailError } = useAppSelector((state) => state.branches);

  useEffect(() => {
    if (branchId) {
      dispatch(fetchBranchDetail(Number(branchId)));
    }
  }, [branchId, dispatch]);

  return (
    <section className="admin-page">
      <header className="detail-header">
        <button className="back-btn" type="button" onClick={() => navigate('/admin/branches')}>
          ←
        </button>
        <h2 className="section-title">직원자료</h2>
      </header>

      {loadingDetail && <p className="loading-text">정보를 불러오는 중입니다...</p>}
      {detailError && <p className="error-text">{detailError}</p>}

      {detail && (
        <EmployeeTab employees={detail.employees} />
      )}
    </section>
  );
};

export default BranchEmployeesPage;
